export const SET_CLASSES = (newClasses) => {
  return {type: "SET_CLASSES", classes: newClasses}
}
